import React, { useEffect, useState } from "react";
import {Link, useNavigate} from "react-router-dom";
import {myroutes} from "../../routes/webroute";
import { Button } from 'primereact/button';
import AnneesacademiquesService from "../anneesacademiques/AnneesacademiquesService";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticate } from "../app/providers/authSlice";

export default function Filarial(props){
    const {activeLink} = props;
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [anneesacademiques, setAnneesacademiques] = useState([])
    const token = useSelector((state) => state.auth.token);
    const navigate = useNavigate();
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)
  

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    }

    //get liste annees academiques
   /* const fetchAnnesacademiques = async () => {
        await AnneesacademiquesService.index(token).then((res) => {
            //console.log(res.data.data.anneesacademiques)
            const dernierAnnee = res.data.data.anneesacademiques[0]; // Supposons que la dernière année est la première dans la liste
            setAnneesacademiques(dernierAnnee.libelleAnneeacademique)
        }).catch(error => {
            console.log(error)
        })
        
    }*/

    useEffect(() => {
       // fetchAnnesacademiques();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])
    return(
        <React.Fragment>
             {/**{ start fil d'arial }**/}
             <div className="card">
                <div className="card-header">
            <div className="row">
                 <div className="col-sm-4 col-md-4 col-lg-4 d-inline-flex" style={{marginBottom:"-10px", fontSize:"13px"}}>
                      <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="#">ACCUEIL</a></li>
                                <li className="breadcrumb-item active" aria-current="page">{activeLink}</li>
                            </ol>
                      </nav>
                </div>

                <div className="col-sm-5 col-md-5 col-lg-5 d-inline-flex" style={{marginBottom:"-10px", fontSize:"13px"}}>
                    ANNEE SCOLAIRE : <b className="text-danger">&nbsp; 2023-2024 | 1EME TRIMESTRE</b>
                </div>
                <div className="col-sm-2 col-md-2 col-lg-2 d-inline-flex mt-0 p-0 m-0 justify-content-end">
                    <div className="btn-group">
                        <button type="button" className="btn btn-outline-danger btn-rounded btn-sm d-inline btn-small" data-mdb-ripple-color="dark" onClick={toggleDropdown}>
                        <i className="fas fa-gears"></i> Liste des modules
                        </button>
                        <button type="button" className="btn btn-outline-danger btn-rounded btn-sm d-inline btn-small dropdown-toggle dropdown-toggle-split" data-mdb-ripple-color="dark" id="dropdownMenuButton" onClick={toggleDropdown}>
                        <span className="visually-hidden">Toggle Dropdown</span>
                        </button>
                        <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`} aria-labelledby="dropdownMenuButton" style={{marginTop:"30px"}}>
                        <Link to={myroutes.enseignants_index} className="dropdown-item" > Liste des enseignants</Link>
                        <Link to={myroutes.classes_index} className="dropdown-item" > Liste des classes</Link>
                        <Link to={myroutes.classesoptions_index} className="dropdown-item" > Liste des options classes</Link>
                        <Link to={myroutes.matieres_index} className="dropdown-item" > Liste des matières</Link>
                        <Link to={myroutes.typescontrats_index} className="dropdown-item" > Liste des types de contrat</Link>
                        <Link to={myroutes.typesevaluations_index} className="dropdown-item" > Liste des types évaluations</Link>
                        <Link to={myroutes.typesinscriptions_index} className="dropdown-item" > Liste des types inscriptions</Link>
                        <Link to={myroutes.cours_index} className="dropdown-item" > Liste des cours</Link>
                        <Link to={myroutes.etablissements_index} className="dropdown-item" > Liste des établissements</Link>
                        </div>
                    </div>
                    </div>
                    <div className="col-sm-1 col-md-1 col-lg-1 " >
                    <Button icon="pi pi-bookmark" severity="warning" aria-label="Notification" style={{height:"30px"}}/>
                    </div>
            </div>
               
                </div>  
             </div>
                {/** end fil d'arial */}
        </React.Fragment>
    )
}